
webpack.register(
    'modules/history-experience-scoring-and-stats/scoring/scoring',
    function() {
        return import('modules/history-experience-scoring-and-stats/scoring/scoring');
    },
    true
);